module.exports = __webpack_public_path__ + "fonts/materialdesignicons-webfont.66f2d33.woff2";